var map = {
	"./enGB/achievements.json": 4304,
	"./enGB/agents.json": 6026,
	"./enGB/assets.json": 5510,
	"./enGB/cards.json": 6313,
	"./enGB/items.json": 2399,
	"./enGB/text.json": 8375,
	"./enGB/tutorial.json": 8334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8552;